'use client';
/* Built In Imports */

/* External Imports */
import { Box, chakra } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/* Internal Imports */
/* Components */

/* Services */
/* Styles */
// import 'react-lazy-load-image-component/src/effects/blur.css';

/**
 * Renders LazyLoad Image Component
 *
 * @param {string} src - Source of the image
 * @returns {ReactElement} LazyLoad Image Component component
 */
const ChakraLazyLoadImage = chakra(LazyLoadImage);
const LazyLoadImageComponent = ({ src = '', className = '', ...props }) => {
  const viewportHeightRef = useRef(
    typeof window !== 'undefined' ? window.innerHeight : 800
  );

  const [customClass, setCustomClass] = useState('loading');

  const handleAfterLoad = () => {
    setCustomClass('loaded');
  };

  return (
    <>
      {/* Desktop */}
      <Box display={{ base: 'none', md: 'block' }} height={props?.height || 'auto'}>
        <ChakraLazyLoadImage
          effect="blur"
          src={src}
          threshold={viewportHeightRef.current}
          afterLoad={handleAfterLoad}
          className={`${className} p-image ${customClass}`}
          {...props}
        />
      </Box>

      {/* Mobile */}
      <Box display={{ base: 'block', md: 'none' }} height={props?.height || 'auto'}>
        <ChakraLazyLoadImage
          effect="blur"
          src={src}
          threshold={viewportHeightRef.current / 2}
          afterLoad={handleAfterLoad}
          className={`${className} p-image ${customClass}`}
          {...props}
        />
      </Box>

      <style global jsx>
        {`
          .lazy-load-image-background {
            width: 100% !important;
          }
          .p-image.loading {
            filter: blur(10px);
            clip-path: inset(0);
          }
          .p-image.loaded {
            filter: blur(0px);
            transition: filter 0.5s linear;
          }
        `}
      </style>
    </>
  );
};

LazyLoadImageComponent.whyDidYouRender = true;
export default LazyLoadImageComponent;
